export default defineNuxtPlugin(async(nuxtApp) => { 
  if (import.meta.server) {
    const host = nuxtApp.ssrContext?.event.node.req.headers.host;
    if (host) useReaderIdStore().setReaderHost(host);
    const subdomain = host?.split(".")[0];
    if (subdomain) useReaderIdStore().setReaderId(subdomain);
  }
});